import { useTranslation } from "react-i18next";
import { PrintDialog } from "../../utils/printDialog";
import { getPdfWorkOrder, printWorkOrder } from "../../../api/work-order";

export const WorkOrderPrintDialog = (props) => {
  const { onClose, open, workOrder, onRefresh } = props;
  const { t } = useTranslation();

  const config = {
    module: "work_order",
    title: t("Print Work Order"),
    printTypeParamName: "printWorkOrderType",
    printTypeOptions: [
      {
        name: "printWorkOrderType",
        value: "",
        label: t("Not Chosen"),
      },
      {
        name: "printWorkOrderType",
        value: "work_order",
        label: t("Work Order"),
      },
      {
        name: "printWorkOrderType",
        value: "customer_work_order",
        label: t("Customer Work Order"),
      },
      {
        name: "printWorkOrderType",
        value: "note",
        label: t("Note"),
      },
    ],
    getPdfFunction: getPdfWorkOrder,
    printFunction: printWorkOrder,
  };

  return (
    <PrintDialog
      open={open}
      onClose={onClose}
      item={workOrder}
      onRefresh={onRefresh}
      config={config}
    />
  );
};
